import { EmployeeDto } from './employee.dto';

/**
 * Validation response for checking if employee has operator access to POS Device.
 */
export class PosValidateOperatorPinResponseDto {
  /**
   * Flag set to true when employee has valid access to POS Device.
   */
  isPosOperatorAccess: boolean;

  /**
   * Flag set to true when employee has manager access
   */
  isManagerAccess?: boolean;

  /**
   * Operator employee partially picked DTO object.
   */
  partialEmployee?: Pick<EmployeeDto, 'id' | 'firstName' | 'lastName'> | null;
}
